import { Injectable } from "@angular/core";
import 'rxjs/add/operator/toPromise';
import { AngularFirestore } from 'angularfire2/firestore';
import firebase from 'firebase/app';
//import 'firebase/storage';
import moment from 'moment';
//import { splitDepsDsl } from "@angular/core/src/view/util";


@Injectable()
export class FirebaseService {

  private snapshotChangesSubscription: any;
  constructor(public afs: AngularFirestore){}

  getMyIdeas(){
    return new Promise<any>((resolve, reject) => {
      //let currentUser = firebase.auth().currentUser;
      //this.snapshotChangesSubscription = this.afs.collection('people').doc(currentUser.uid).collection('ideas').snapshotChanges()
      this.snapshotChangesSubscription = this.afs.collection('ideas').snapshotChanges()
      .subscribe(snapshots => {
        resolve(snapshots);
      })
    });
  }

  getCategories(){
    return new Promise<any>((resolve, reject) => {
      this.snapshotChangesSubscription = this.afs.collection('categories').snapshotChanges()
      .subscribe(snapshots => {
        resolve(snapshots);
      })
    });
  }

  unsubscribeOnLogOut(){
    //remember to unsubscribe from the snapshotChanges
    // debugger;
    this.snapshotChangesSubscription.unsubscribe();
  }

  updateIdea(ideaKey, value){
    return new Promise<any>((resolve, reject) => {
      //let currentUser = firebase.auth().currentUser;
      //this.afs.collection('people').doc(currentUser.uid).collection('ideas').doc(ideaKey).set(value)
      this.afs.collection('ideas').doc(ideaKey).set(value)
      .then(
        res => resolve(res),
        err => reject(err),
      )
    })
  }

  deleteIdea(ideaKey){
    return new Promise<any>((resolve, reject) => {
      //let currentUser = firebase.auth().currentUser;
      //this.afs.collection('people').doc(currentUser.uid).collection('ideas').doc(ideaKey).delete()
      this.afs.collection('ideas').doc(ideaKey).delete()
      .then(
        res => resolve(res),
        err => reject(err)
      )
    })
  }

  createIdea(value) {
    return new Promise<any>((resolve, reject) => {
      let currentUser = firebase.auth().currentUser;
      //this.afs.collection('people').doc(currentUser.uid).collection('ideas').add({
      this.afs.collection('ideas').add({
        image: value.image,
        categorie: value.categorie,
        title: value.title,
        description: value.description,
        town: value.town,
        url: value.url,
        cre_user: currentUser.uid,
        cre_dat: moment().format(),
        mod_user: currentUser.uid,
        mod_dat: moment().format()
      })
        .then(
          res => resolve(res),
          err => reject(err)
        )
    })
  }

  encodeImageUri(imageUri, callback) {
    var c = document.createElement('canvas');
    var ctx = c.getContext("2d");
    var img = new Image();
    img.onload = function () {
      var aux:any = this;
      c.width = aux.width;
      c.height = aux.height;
      ctx.drawImage(img, 0, 0);
      var dataURL = c.toDataURL("image/jpeg");
      callback(dataURL);
    };
    img.src = imageUri;
  }

  uploadImage(imageURI, randomId){
    return new Promise<any>((resolve, reject) => {
      let storageRef = firebase.storage().ref();
      let imageRef = storageRef.child('image').child(randomId);
      this.encodeImageUri(imageURI, function(image64){
        imageRef.putString(image64, 'data_url')
        .then(snapshot => {
          snapshot.ref.getDownloadURL()
          .then(res => resolve(res))
        }, err => {
          reject(err);
        })
      })
    })
  }  
}



// WEBPACK FOOTER //
// ./src/pages/services/firebase.service.ts